export enum NotificationPresentationType {
  Success,
  UserActionRequired,
  UnexpectedError
}